import * as ReactRedux from 'react-redux';
import PosSaleNoLoginComponent from './PosSaleNoLoginComponent';
import { AppState } from '../app/app.types';
import { retryFailedPayment } from '../payments/Actions';
import { FailedPaymentRequest } from '../payments/Types';

const mapDispatchToProps = (dispatch) => {
  return {
    retryFailedPayment: (failedPaymentRequest: FailedPaymentRequest) =>
      dispatch(retryFailedPayment(failedPaymentRequest))
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    paymentsState: state.paymentsState
  };
};

const PosSaleNoLogin = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(PosSaleNoLoginComponent);

export default PosSaleNoLogin;


// WEBPACK FOOTER //
// ./src/pos/PosSaleNoLogin.tsx